export default __webpack_public_path__ + "static/media/img_19.1cb9c362.jpg";